import { CartButton } from "./cartButton"
import { MyAccount } from "./myAccountHeader"
// import { MyOrdersButton } from "./myOrders"
// import { NotificationsButton } from "./notificationsButton"
// import { ReferralButton } from "./referralButton"
import styles from "./style.module.css"
import { WishlistButton } from "./wishlistButton"

export const SideNavBarButtons = () => {

    return(

        <div className={styles.container}>

        {/* sideNavButtons */}

        <MyAccount/>
        {/* <NotificationsButton/> */}
        <CartButton/>
        {/* <MyOrdersButton/> */}
        <WishlistButton/>
        {/* <ReferralButton/> */}

        </div>

    )

}